import { Transform } from 'class-transformer';
import { IsNotEmpty, IsString, IsArray, ArrayNotEmpty } from 'class-validator';

export class TemplateForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsArray()
  @ArrayNotEmpty()
  @Transform(({ obj }) => obj.files)
  files: File[];
}
